module.exports = __webpack_public_path__ + "72b7c3a3703a345337878a1634ce7f62.webp";